import { z } from "zod";
import {
    EntityProfileIndustry,
    EntityProfileRevenueBracket,
    EntityProfileType,
} from "@common/types/entity";
import { WorkspaceTimezone } from "@common/workspaceTimezone";

export const entityProfileFormSchema = z.object({
    name: z.string().min(1, "Business name is required"),
    legalType: z.nativeEnum(EntityProfileType, {
        required_error: "Select an entity type",
    }),
    industries: z
        .array(z.nativeEnum(EntityProfileIndustry))
        .min(1, "Select at least one industry"),
    industryOther: z.string().optional(),
    annualRevenue: z.nativeEnum(EntityProfileRevenueBracket, {
        required_error: "Select an annual revenue bracket",
    }),
    country: z.string().min(1, "Select a country"),
});

export type EntityProfileFormSchema = z.infer<typeof entityProfileFormSchema>;

export const profileFormSchema = entityProfileFormSchema.extend({
    firstName: z.string().min(1, "First name is required"),
    lastName: z.string().min(1, "Last name is required"),
    unverifiedPhoneNumber: z
        .string()
        .min(1, "Phone number is required")
        .regex(/^\d{10}$/, "Enter a valid 10-digit phone number"),
    source: z.string(),
    timezone: z.nativeEnum(WorkspaceTimezone, {
        required_error: "Select a timezone",
    }),
});

export type ProfileFormSchema = z.infer<typeof profileFormSchema>;
